import { render, staticRenderFns } from "./Impersonate.vue?vue&type=template&id=635e2b18&scoped=true&"
import script from "./Impersonate.vue?vue&type=script&lang=js&"
export * from "./Impersonate.vue?vue&type=script&lang=js&"
import style0 from "./Impersonate.vue?vue&type=style&index=0&id=635e2b18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635e2b18",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VCard,VIcon,VProgressCircular})
